import './utils/polyfill-web';
import './globals';
import './utils/i18n';

import './legacy/api';

import './legacy/ui-common';
import './legacy/ui-web';

import './legacy/views-web';

import './all';
import './desktop';
